import React from 'react'
import styles from './CommentThread.module.sass'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { CommentAuthor } from 'components/cards/CommentThreadCard/CommentThreadCard'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import CommentLinkedElement from './CommentLinkedElement'
import RecipientsNotified from './RecipientsNotified'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'

const AuthorAndDate = ({
	author,
	date,
	padded,
	nameOnly,
	linkedTo,
	processId,
	providerEstablishment,
	className,
	displayDelay = 600,
	notifiedEntities = [],
	notifiedEstablishments = [],
}) => {
	return (
		<HStack
			className={`${styles['selected-comment-author-date']} ${
				padded ? styles['padded'] : ''
			} ${className ?? ''}`}
			align='center'
			gap='xsmall'
		>
			{!nameOnly && <CommentAuthor author={author} />}
			<VStack className={linkedTo ? styles['--linked-to'] : ''}>
				<HStack align='center' gap='xsmall'>
					<h5 className={styles['selected-comment-author']}>
						{providerEstablishment
							? providerEstablishment.name
							: author?.name ?? ''}
					</h5>
					<Tooltip
						displayDelay={displayDelay}
						alwaysBelow
						content={
							<RecipientsNotified
								notifiedEntities={notifiedEntities}
								notifiedEstablishments={notifiedEstablishments}
							/>
						}
					>
						<small>{date}</small>
					</Tooltip>
				</HStack>
				{linkedTo && (
					<CommentLinkedElement
						linkedTo={linkedTo}
						processId={processId}
					/>
				)}
			</VStack>
		</HStack>
	)
}

export default AuthorAndDate
